import '@angular/compiler';
import { LayoutAuthComponent } from './layout.auth/layout.auth.component';
import { PageMypageEditComponent } from './page.mypage.edit/page.mypage.edit.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageSettingsComponent } from './page.settings/page.settings.component';
import { PageHomeComponent } from './page.home/page.home.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PageRecordsComponent } from './page.records/page.records.component';
import { PageAnalysisComponent } from './page.analysis/page.analysis.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { LayoutAppComponent } from './layout.app/layout.app.component';
import { PageConstitutionComponent } from './page.constitution/page.constitution.component';
import { PageChatbotComponent } from './page.chatbot/page.chatbot.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageOnboardingComponent } from './page.onboarding/page.onboarding.component';
import { ComponentNavBottomComponent } from './component.nav.bottom/component.nav.bottom.component';
import { PageRootComponent } from './page.root/page.root.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageLoginComponent } from './page.login/page.login.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';

const INDEX_PAGE = "home";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutAppComponent,
        "children": [
            {
                "path": "mypage/edit",
                component: PageMypageEditComponent,
                "app_id": "page.mypage.edit"
            },
            {
                "path": "settings",
                component: PageSettingsComponent,
                "app_id": "page.settings"
            },
            {
                "path": "home",
                component: PageHomeComponent,
                "app_id": "page.home"
            },
            {
                "path": "mypage",
                component: PageMypageComponent,
                "app_id": "page.mypage"
            },
            {
                "path": "records",
                component: PageRecordsComponent,
                "app_id": "page.records"
            },
            {
                "path": "analysis",
                component: PageAnalysisComponent,
                "app_id": "page.analysis"
            },
            {
                "path": "constitution",
                component: PageConstitutionComponent,
                "app_id": "page.constitution"
            },
            {
                "path": "chatbot",
                component: PageChatbotComponent,
                "app_id": "page.chatbot"
            }
        ]
    },
    {
        component: LayoutAuthComponent,
        "children": [
            {
                "path": "onboarding",
                component: PageOnboardingComponent,
                "app_id": "page.onboarding"
            },
            {
                "path": "",
                component: PageRootComponent,
                "app_id": "page.root"
            },
            {
                "path": "login",
                component: PageLoginComponent,
                "app_id": "page.login"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    path: '',
    pathMatch: 'full',
    redirectTo: INDEX_PAGE
}, {
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }
